import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const Index = ({
  resetOtpModelVisable,
  setResetOtpModelVisable,
  handleResetOtp,
  isLoading,
}) => {
  return (
    <Modal
      isOpen={resetOtpModelVisable}
      toggle={() => {
        setResetOtpModelVisable(false);
      }}
      centered
    >
      <ModalHeader
        className="bg-light p-3"
        id="resetOtpModalLabel"
        toggle={() => {
          setResetOtpModelVisable(false);
        }}
      >
        Reset 2FA
      </ModalHeader>
      <div className="tablelist-form">
        <ModalBody>
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            id="modal-id"
          >
            <span className="mt-4 mb-4 text-center">
              Are you sure you want to reset this user&apos;s Google Authenticator (2FA)?
              <br />
              They will need to set it up again on their next login.
            </span>
            <div className="hstack gap-2 justify-content-center">
              <button
                type="button"
                className="btn btn-light"
                disabled={isLoading}
                onClick={() => {
                  setResetOtpModelVisable(false);
                }}
              >
                Close
              </button>
              <button
                className="btn btn-danger"
                id="reset-otp-btn"
                disabled={isLoading}
                onClick={() => {
                  handleResetOtp();
                }}
              >
                Yes, Reset
              </button>
            </div>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
};

export default Index;
